(() => {
  const root = document.querySelector('.lab');
  if (!root) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 目錄：讀正文的 h2/h3，捲到哪一章就亮哪一項（藍字加左側 2px 線，不只靠顏色）
  const toc = root.querySelector('.toc');
  const body = root.querySelector('.article');
  if (toc && body) {
    const headings = [...body.querySelectorAll('h2, h3')].filter((h) => h.textContent.trim() && !h.closest('.faq-item'));
    headings.forEach((h, i) => {
      if (!h.id) h.id = 'sec-' + (i + 1);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      if (h.tagName === 'H3') a.classList.add('sub');
      li.append(a);
      toc.append(li);
    });
    const wrap = toc.closest('div');
    if (headings.length < 2 && wrap) wrap.hidden = true;
    if (headings.length && 'IntersectionObserver' in window) {
      const links = [...toc.querySelectorAll('a')];
      const io = new IntersectionObserver((entries) => {
        const hit = entries.find((e) => e.isIntersecting);
        if (!hit) return;
        links.forEach((l) => {
          const on = l.hash === '#' + hit.target.id;
          l.classList.toggle('active', on);
          if (on) l.setAttribute('aria-current', 'location'); else l.removeAttribute('aria-current');
        });
      }, { rootMargin: '-10% 0px -65% 0px', threshold: 0 });
      headings.forEach((h) => io.observe(h));
      links[0] && links[0].classList.add('active');
    }
  }

  // 側欄：桌機整條跟著捲，放不下的部分在側欄裡面捲；目錄與諮詢永遠在手邊
  const aside = root.querySelector('.aside');
  if (aside) {
    const decide = () => aside.classList.toggle('is-sticky', window.innerWidth > 1100);
    decide();
    window.addEventListener('resize', decide, { passive: true });
    window.addEventListener('load', decide);
  }

  // 色帶：朝游標微彎 12px，離開回正；只在第一屏，減少動態時關掉
  const hero = root.querySelector('[data-ribbon]');
  const ribbon = hero && hero.querySelector('.ribbon svg');
  if (hero && ribbon && !reduce && window.matchMedia('(pointer: fine)').matches) {
    let raf = 0;
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      const dx = ((e.clientX - r.left) / r.width - 0.5) * 24;
      const dy = ((e.clientY - r.top) / r.height - 0.5) * 12;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => { ribbon.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)'; });
    }, { passive: true });
    hero.addEventListener('pointerleave', () => { ribbon.style.transform = ''; });
  }

  // 內文導流列：商品連結用商店公開的 /products/handle.js 補縮圖與價格，系列連結用 /collections/handle.json 補縮圖。
  // 抓不到（跨網域、下架）就維持文字列；本機預覽由 render-local 先把資料放進 window.__labLinkData。
  const lists = root.querySelectorAll('.article ul.kb-links');
  if (lists.length) {
    const chevron = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const goText = { product: '看規格與報價', collection: '看全系列', article: '閱讀文章', other: '前往' };
    const kindOf = (u) => /\/products\//.test(u.pathname) ? 'product' : /\/collections\//.test(u.pathname) ? 'collection' : /\/blogs\//.test(u.pathname) ? 'article' : 'other';
    const money = (cents) => 'NT$ ' + Math.round(cents / 100).toLocaleString('zh-Hant-TW');
    const preset = window.__labLinkData || {};
    const thumb = (src) => { try { const u = new URL(src, location.href); if (/shopify\.com$/.test(u.hostname) && !u.searchParams.has('width')) u.searchParams.set('width', '160'); return u.href; } catch (e) { return src; } };
    lists.forEach((ul) => ul.querySelectorAll('a').forEach(async (a) => {
      let u; try { u = new URL(a.getAttribute('href') || '', location.href); } catch (e) { return; }
      const kind = kindOf(u);
      a.dataset.kind = kind;
      const bodyEl = document.createElement('span');
      bodyEl.className = 'kb-body';
      while (a.firstChild) bodyEl.append(a.firstChild);
      a.append(bodyEl);
      const go = document.createElement('span');
      go.className = 'go';
      go.innerHTML = '<span>' + goText[kind] + '</span>' + chevron;
      a.append(go);
      if (kind !== 'product' && kind !== 'collection') return;
      const handle = decodeURIComponent(u.pathname.split('/').filter(Boolean).pop() || '');
      let data = preset[kind + ':' + handle];
      if (!data) {
        if (u.origin !== location.origin) return;
        try {
          const r = await fetch(kind === 'product' ? '/products/' + encodeURIComponent(handle) + '.js' : '/collections/' + encodeURIComponent(handle) + '.json', { credentials: 'same-origin' });
          if (!r.ok) return;
          const j = await r.json();
          data = kind === 'product' ? { image: j.featured_image, price: j.price } : { image: j.collection && j.collection.image && j.collection.image.src };
          if (kind === 'collection' && !data.image) { // 系列沒有封面圖就借第一個商品的圖
            const r2 = await fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=1', { credentials: 'same-origin' });
            if (r2.ok) { const j2 = await r2.json(); const p0 = j2.products && j2.products[0]; data.image = p0 && p0.images && p0.images[0] && p0.images[0].src; }
          }
        } catch (e) { return; }
      }
      if (data.image) {
        const img = document.createElement('img');
        img.src = thumb(data.image); img.alt = ''; img.loading = 'lazy'; img.width = 72; img.height = 72;
        a.prepend(img);
        a.classList.add('has-thumb');
      }
      if (kind === 'product' && data.price > 0) {
        const p = document.createElement('span');
        p.className = 'price';
        p.textContent = money(data.price);
        bodyEl.append(p);
      }
    }));
  }
})();
